<script setup lang="ts">
import { onActivated, onDeactivated, onMounted, onUnmounted, useTemplateRef } from 'vue';
import { FontAwesomeIcon } from '@shared/plugin/icons';

const emit = defineEmits<{ filesDropped: [files: File[]] }>();

const dropzoneRef = useTemplateRef('dropzone');

function hasFiles(e: DragEvent): boolean {
  const types = e.dataTransfer?.types;
  return !!types && Array.from(types).includes('Files');
}

function activateDropzone(e: DragEvent) {
  if (!hasFiles(e)) return;

  dropzoneRef.value?.classList.remove('hidden');
}

function deactivateDropzone() {
  dropzoneRef.value?.classList.add('hidden');
}

function dragHandler(e: DragEvent) {
  e.dataTransfer!.dropEffect = 'copy';
  e.preventDefault();
}

function dropHandler(e: DragEvent) {
  const droppedFiles = e.dataTransfer?.files;
  if (!droppedFiles) return;

  emit('filesDropped', Array.from(droppedFiles));
  e.preventDefault();
  deactivateDropzone();
}

onMounted(() => {
  window.removeEventListener('dragenter', activateDropzone);
  window.addEventListener('dragenter', activateDropzone);

  dropzoneRef.value?.addEventListener('dragenter', dragHandler);
  dropzoneRef.value?.addEventListener('dragover', dragHandler);
  dropzoneRef.value?.addEventListener('dragleave', deactivateDropzone);
  dropzoneRef.value?.addEventListener('drop', dropHandler);
});
onActivated(() => {
  window.removeEventListener('dragenter', activateDropzone);
  window.addEventListener('dragenter', activateDropzone);
});
onUnmounted(() => {
  window.removeEventListener('dragenter', activateDropzone);
});
onDeactivated(() => {
  window.removeEventListener('dragenter', activateDropzone);
});
</script>

<template>
  <Teleport to="body">
    <div
      ref="dropzone"
      class="fixed inset-0 z-overlay hidden h-screen w-screen bg-black/50 backdrop-blur-xs"
    >
      <div class="pointer-events-none flex h-full items-center justify-center">
        <div
          class="rounded-lg border-4 border-dashed border-primary bg-white/90 p-12 text-center shadow-2xl"
        >
          <FontAwesomeIcon icon="far fa-file-upload" class="text-6xl mb-4 text-primary" />
          <p class="mb-2 text-xl font-semibold text-gray-800">Sleep bestanden hierheen</p>
          <p class="text-sm text-gray-600">Laat los om te uploaden</p>
        </div>
      </div>
    </div>
  </Teleport>
</template>
